import GenerateAPI from '../generate.js'


const config = {
    list: {
        url: '/client/record/paymentlist',
        apiType: 'check',
    },
    detail: {
        url: '/client/record/paymentlist/detail',
        apiType: 'check',
    },
}

const apiPayRecord = GenerateAPI.generate(config)

export default apiPayRecord
